export const BASE_STATIC_URL = '//l7-static.pages.dev/'
export const STATIC_URL = '//l7-static.pages.dev/image/'
